module.exports = __webpack_public_path__ + "static/media/IMG_1977.591d60e6.jpg";